module.exports = __webpack_public_path__ + "img/tarj2-4.eab5178f.svg";